import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "axios";
import { useAppContext } from "../../../../../AppContext";
//import SearchDropdown from "../../../../search/seatchDropdown";

function ViewClient() {
  const [title] = useState("User");
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);

  const params = useParams();
  const location = useLocation();
  const { chimeraserv, components, user } = useAppContext();
  const props = { chimeraserv, components, user };

  const headers = {
    Authorization: props.user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const loadData = useCallback(async () => {
    try {
      const response = await axios.get(
        props.chimeraserv.urlGet + "/user/" + params.uid,
        { headers }
      );
      setData(Array.isArray(response.data) ? response.data : [response.data]);
      setLoad(true);
    } catch (error) {
      setData([]);
      setLoad(true);
    }
    // eslint-disable-next-line
  }, [params.uid, props.chimeraserv.urlGet, props.user.data.usrKey]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const valueChange = async (userData, key) => {
    const updatedData = { ...userData, status: userData.status === 1 ? 0 : 1 };
    try {
      await axios.put(props.chimeraserv.urlPost + "/user/update", updatedData, {
        headers,
      });
      setLoad(false);
      setData([updatedData]);
      setLoad(true);
    } catch (error) {
      setLoad(false);
      setData([updatedData]);
      setLoad(true);
    }
  };

  const Loader = props.components.setting[1].component;

  // Build edit link path
  const getEditPath = (data) => {
    const pathParts = location.pathname.split("/").splice(0, 3).join("/");
    return `${pathParts}/edit/${data._id}`;
  };

  return (
    <div className={["custForm", "custView"].join(" ")}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={["viewTitle"]}>View User</div>
      {!load ? (
        <Loader />
      ) : (
        <div className={"form"}>
          {data.map((userData) => (
            <div key={userData._id}>
              <div className={["form-group"]}>
                <label htmlFor="exampleInputEmail1">Username</label>
                <div className={["field", "value"].join(" ")}>
                  {userData.username}
                </div>
              </div>
              {props.user.data.level === 0 ? (
                <div className={["form-group"]}>
                  <label htmlFor="exampleInputEmail1">Password</label>
                  <div className={["field", "value"].join(" ")}>
                    {userData.password}
                  </div>
                </div>
              ) : (
                <div />
              )}
              <div className={["form-group"]}>
                <label htmlFor="exampleInputEmail1">Email</label>
                <div className={["field", "value"].join(" ")}>
                  {userData.email}
                </div>
              </div>
              <div className={["form-group"]}>
                <label htmlFor="exampleInputEmail1">Group</label>
                <div className={["field", "value"].join(" ")}>
                  {userData.group}
                </div>
              </div>
              <div className={["form-group"]}>
                <label htmlFor="exampleInputEmail1">Status</label>
                <div className={["field", "value"].join(" ")}>
                  {userData.status ? "Active" : "Inactive"}
                </div>
              </div>
              {props.user.data.level === 0 ? (
                <div className={["actions", "actionsAdmin"].join(" ")}>
                  <Link
                    to={getEditPath(userData)}
                    className={["btn btn-primary"]}
                  >
                    Edit
                  </Link>
                  <button
                    type={"button"}
                    onClick={() => valueChange(userData)}
                    className={["btn", "btn-primary", "disable"].join(" ")}
                  >
                    {userData.status ? "Disable" : "Enable"}
                  </button>
                </div>
              ) : (
                <div />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ViewClient;
